import { addToCart } from '~/js/lib/cart'; // eslint-disable-line
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import { applyReadMoreTruncation } from '~/js/utils/util-functions';

export default (node) => {
  /**
   * Data + elements
   */
  let lightboxDimension = null;

  const dataVariants = JSON.parse(node.dataset.variants);
  const optionsName = JSON.parse(node.dataset.optionsName);
  const buttonAddToCart = document.querySelector(
    '[button-add-to-cart-wrapper]'
  );
  const buttonAddToCartDisabled = document.querySelector(
    '[data-out-of-stock-button-wrapper]'
  );

  let addToCartButton = null;


  const variantsData = JSON.parse(
    document.getElementById('variant-metafields')?.textContent || '{}'
  );

  const outOfStockButton = document.querySelector('[data-out-of-stock-button-wrapper]');

  /**
   * Functions
   */

  const formatMoney = (amount, minimumFractionDigits = 0) => {
    let locale = window.Shopify.locale;
    let newAmount = amount / 100;
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: locale === "en" ? "USD" : "CAD",
      currencyDisplay: "narrowSymbol", // just "$" instead of "CA$"
      minimumFractionDigits,
      maximumFractionDigits: 2,
      useGrouping: true, // thousands separators (commas in EN, spaces in FR)
    }).format(newAmount);
  }

  // Normalizes a Shopify weight metafield ({ value, unit }) to kg and lbs.
  // Returns null when the metafield is missing, empty (`[]`) or invalid.
  // The entered value is kept as-is for its own unit so it never drifts from
  // what was saved in Shopify; only the other unit is converted.
  const KG_PER_LB = 0.45359237; // exact international definition
  const WEIGHT_UNITS = {
    kg: { system: 'kg', factor: 1 },
    kilograms: { system: 'kg', factor: 1 },
    g: { system: 'kg', factor: 0.001 },
    grams: { system: 'kg', factor: 0.001 },
    lb: { system: 'lb', factor: 1 },
    lbs: { system: 'lb', factor: 1 },
    pounds: { system: 'lb', factor: 1 },
    oz: { system: 'lb', factor: 1 / 16 },
    ounces: { system: 'lb', factor: 1 / 16 },
  };

  const getWeightInKgAndLbs = (weightData) => {
    if (!weightData || typeof weightData !== 'object' || Array.isArray(weightData)) {
      return null;
    }
    const value = parseFloat(weightData.value);
    if (!Number.isFinite(value) || value <= 0) {
      return null;
    }
    const unit = WEIGHT_UNITS[String(weightData.unit || '').toLowerCase()];
    if (!unit) {
      return null;
    }
    if (unit.system === 'kg') {
      const kg = value * unit.factor;
      return { kg, lbs: kg / KG_PER_LB };
    }
    const lbs = value * unit.factor;
    return { kg: lbs * KG_PER_LB, lbs };
  };

  // Used to update the Klaviyo back in stock button
  const updateBackInStockButton = (variant) => {
    const bisTrigger = document.querySelector('.klaviyo-bis-trigger');
    if (!bisTrigger || !variant) return;

    if (variant) {
      bisTrigger.classList.remove('hidden');
      bisTrigger.classList.add('!block');
      bisTrigger.setAttribute('data-variant-id', variant);
      const clone = bisTrigger.cloneNode(true);
      bisTrigger.replaceWith(clone);
    } else {
      bisTrigger.classList.add('hidden');
      bisTrigger.classList.remove('!block');
    }
  };

  const handleVariantButtonClick = (variantId) => {

    // if no variant found, select the first variant available with the color selected
    let variant = dataVariants.find((variant) => {
      return variant.id === variantId;
    });
    if (!variant) {
      // hide add to cart button
      buttonAddToCart.classList.add('hidden');
      // show out of stock button
      outOfStockButton.classList.remove('hidden');

    } else {

        // show add to cart button
        buttonAddToCart.classList.remove('hidden');
        // hide out of stock button
        outOfStockButton.classList.add('hidden');


      // update the price
      const price = variant.price;
      const priceEl = node.querySelector('[data-product-price]');
      priceEl.textContent = formatMoney(variant.price_without_money);
      const compareAtPrice = variant.compare_at_price;
      const compareAtPriceEl = node.querySelector(
        '[data-product-compare-at-price]'
      );
      const compareAtPriceWithoutMoney = variant.compare_at_price_without_money;
      compareAtPriceEl.textContent = formatMoney(compareAtPriceWithoutMoney);
      if (
        (compareAtPriceWithoutMoney &&
        compareAtPriceWithoutMoney.length > 0 &&
        Number(compareAtPriceWithoutMoney) !== 0)
      ) {
        compareAtPriceEl.classList.remove('hidden');
      } else {
        compareAtPriceEl.classList.add('hidden');
      }

      if (Number(variant.price_without_money) === Number(compareAtPriceWithoutMoney) || Number(compareAtPriceWithoutMoney) === 0) {
        compareAtPriceEl.classList.add('hidden');
      } else {
        compareAtPriceEl.classList.remove('hidden');
      }


      // update price in add to cart button
      const priceButtonAddToCart = node.querySelector('[data-add-to-cart-price]');
      priceButtonAddToCart.textContent = formatMoney(variant.price_without_money);

      if (variant.available) {
        buttonAddToCart.classList.remove('hidden');
        buttonAddToCartDisabled.classList.add('hidden');
      } else {
        buttonAddToCart.classList.add('hidden');
        buttonAddToCartDisabled.classList.remove('hidden');
      }

      // update the variant id in the add to cart button
      addToCartButton.dataset.variantId = variant.id;

      // Dispatch the event so other components (like FAQ) can react
      let isColor = false
      if (optionsName && optionsName.length > 0) {
        const checkName = optionsName[0].toUpperCase();
        isColor = checkName.includes('COLOR') || checkName.includes('COLOUR');
      }
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: { variantId: variant.id, color: isColor ? variant.option1 : null },
        })
      );

      // update content based on variant
      updateContentBasedOnVariant(variant);

      // Klaviyo back in stock button
      if (!variant.available) {
        updateBackInStockButton(variant.id);
      }
    }
  };

  const updateContentBasedOnVariant = (variant) => {
    // show/hide the label stock in stock and out of stock
    const variantId = variant.id;
    const variantData = variantsData?.[String(variantId)];

    // update the vendor variant id in the add to cart button
    const allVendorVariantIds = node.querySelectorAll('[data-vendor-variant-id]');
    allVendorVariantIds.forEach((vendorVariantId) => {
      if (vendorVariantId.dataset.vendorVariantId === variantId) {
        vendorVariantId.classList.remove('hidden');
      } else {
        vendorVariantId.classList.add('hidden');
      }
    });

    if (variantData?.variant_title) {
      const variantTitleEl = node.querySelector('[data-variant-title]');
      if (variantTitleEl) {
        variantTitleEl.innerHTML = variantData.variant_title + ' | ' + variantData.sku;
      }
    }

    // show/hide the faq based on the variant id
    const faqVariantData = document.querySelectorAll(
      '[data-faq-variant-id]'
    );
    if (faqVariantData.length > 0) {
      faqVariantData.forEach((item) => {
        if (item.dataset.faqVariantId === variantId) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    const warrantyVariantData = document.querySelectorAll(
      '[data-warranty-variant-id]'
    );
    if (warrantyVariantData.length > 0) {
      warrantyVariantData.forEach((item) => {
        if (item.dataset.warrantyVariantId === variantId) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    // show/hide the preorder banner based on the variant id
    const preorderVariantData = document.querySelectorAll(
      '[data-preorder-variant-id]'
    );
    if (preorderVariantData.length > 0) {
      preorderVariantData.forEach((item) => {
        if (item.dataset.preorderVariantId === variantId) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    // show the preorder delivery promise text instead of the calculated date range
    const deliveryPromiseDefaultEl = document.querySelector('[data-delivery-promise-default]');
    const deliveryPromisePreorderEl = document.querySelector('[data-delivery-promise-preorder]');
    if (deliveryPromiseDefaultEl && deliveryPromisePreorderEl) {
      if (variant.is_preorder) {
        deliveryPromiseDefaultEl.classList.add('hidden');
        deliveryPromisePreorderEl.classList.remove('hidden');
      } else {
        deliveryPromiseDefaultEl.classList.remove('hidden');
        deliveryPromisePreorderEl.classList.add('hidden');
      }
    }


    const variantDescriptionEl = document.querySelector(
      '[data-filter-tab-description]'
    );
    if (variantDescriptionEl) {
      const baseDescription = variantData?.description ? variantData.description : variantDescriptionEl.dataset.filterTabDescription;
      variantDescriptionEl.innerHTML = baseDescription + (variantData?.origin_notice || '');
      if (variantDescriptionEl.dataset.readMoreEnabled === 'true') {
        const wordLimit = parseInt(variantDescriptionEl.dataset.readMoreWordLimit, 10) || 75;
        applyReadMoreTruncation(variantDescriptionEl, wordLimit);
      }
    }

    const variantDimensionsEl = document.querySelector(
      '[data-filter-tab-dimensions]'
    );
    if (variantDimensionsEl) {
      variantDimensionsEl.innerHTML = '';
      const wrapper = document.createElement('div');
      wrapper.classList.add(
        'grid',
        'grid-cols-1',
        'md:grid-cols-5',
        'gap-2',
        'pointer-events-auto',
        'dimension_gallery'
      );

      // const imageWrapper = document.createElement('a');
      // imageWrapper.classList.add('col-span-1', 'md:col-span-2');
      // imageWrapper.href = variantData?.dimension_image_en ? variantData.dimension_image_en : variantData?.dimension_image_fr;
      // imageWrapper.target = '_blank';
      // imageWrapper.dataset.pswpWidth = 2000;
      // imageWrapper.dataset.pswpHeight = 2000;
      // imageWrapper.dataset.pswpSrc = variantData?.dimension_image_en ? variantData.dimension_image_en : variantData?.dimension_image_fr;

      // const image = document.createElement('img');

      // image.classList.remove('hidden');
      // if (variantData?.current_locale === 'en') {
      //   image.src = variantData?.dimension_image_en ? variantData.dimension_image_en : image.classList.add('hidden');
      // } else {
      //   image.src = variantData?.dimension_image_fr ? variantData.dimension_image_fr : image.classList.add('hidden');
      // }

      const imageWrapper = document.createElement('a');
      imageWrapper.classList.add('col-span-1', 'md:col-span-2');
      imageWrapper.target = '_blank';
      imageWrapper.dataset.pswpWidth = 2000;
      imageWrapper.dataset.pswpHeight = 2000;

      const image = document.createElement('img');
      image.classList.remove('hidden');

      // Normalize locale (handles "fr", "fr-CA", "fr_CA", etc.)
      const locale = (variantData?.current_locale || '').toLowerCase();
      const isEnglish = locale.startsWith('en');

      // Pick the locale-specific image first, then optionally fall back to the other language
      const preferredSrc = isEnglish
        ? variantData?.dimension_image_en
        : variantData?.dimension_image_fr;

      const fallbackSrc = isEnglish
        ? variantData?.dimension_image_fr
        : variantData?.dimension_image_en;

      const finalSrc = preferredSrc || fallbackSrc;

      // Apply src (or hide if nothing exists)
      if (finalSrc) {
        image.src = finalSrc;

        // Make the wrapper + PhotoSwipe source match the same image
        imageWrapper.href = finalSrc;
        imageWrapper.dataset.pswpSrc = finalSrc;

        image.classList.remove('hidden');
      } else {
        image.classList.add('hidden');
      }

      // End of locale/image selection logic

      image.alt = 'dimension image';
      image.classList.add('w-full', 'h-auto', 'object-cover', 'aspect-square');
      imageWrapper.appendChild(image);
      wrapper.appendChild(imageWrapper);

      const textElements = document.createElement('ul');
      textElements.classList.add(
        'flex',
        'flex-col',
        'gap-2',
        'col-span-1',
        'md:col-start-3',
      );

      let assembledWidth = '';
      if (
        variantData?.assembled_width_in_mm.length > 0 ||
        variantData?.assembled_width_inch.length > 0
      ) {
        const widthCm = variantData?.assembled_width_in_mm.length > 0 ? (variantData?.assembled_width_in_mm / 10).toFixed(2) : variantData?.assembled_width_inch.length > 0 ? (variantData?.assembled_width_inch * 2.54).toFixed(2) : '';
        const widthIn = variantData?.assembled_width_inch.length > 0 ? variantData?.assembled_width_inch : variantData?.assembled_width_in_mm.length > 0 ? (variantData?.assembled_width_in_mm / 25.4).toFixed(2) : '';
        if (variantData?.current_country === 'CA') {
          assembledWidth = `${widthCm} cm (${widthIn} in)`;
        } else {
          assembledWidth = `${widthIn} in (${widthCm} cm)`;
        }
      }

      if (assembledWidth.length > 0) {
        const itemWrapper = document.createElement('li');
        itemWrapper.classList.add('flex', 'flex-row', 'gap-2');
        itemWrapper.innerHTML = `
          <div class="font-bold">${variantData?.translation_width}:</div>
          <div>${assembledWidth}</div>
        `;
        textElements.appendChild(itemWrapper);
      }

      let assembledHeight = '';
      if (
        variantData?.assembled_height_in_mm.length > 0 ||
        variantData?.assembled_height_inch.length > 0
      ) {
        const heightCm = variantData?.assembled_height_in_mm.length > 0 ? (variantData?.assembled_height_in_mm / 10).toFixed(2) : variantData?.assembled_height_inch.length > 0 ? (variantData?.assembled_height_inch * 2.54).toFixed(2) : '';
        const heightIn = variantData?.assembled_height_inch.length > 0 ? variantData?.assembled_height_inch : variantData?.assembled_height_in_mm.length > 0 ? (variantData?.assembled_height_in_mm / 25.4).toFixed(2) : '';
        if (variantData?.current_country === 'CA') {
          assembledHeight = `${heightCm} cm (${heightIn} in)`;
        } else {
          assembledHeight = `${heightIn} in (${heightCm} cm)`;
        }
      }
      if (assembledHeight.length > 0) {
        const itemWrapperHeight = document.createElement('li');
        itemWrapperHeight.classList.add('flex', 'flex-row', 'gap-2');
        itemWrapperHeight.innerHTML = `
          <div class="font-bold">${variantData?.translation_height}:</div>
          <div>${assembledHeight}</div>
        `;
        textElements.appendChild(itemWrapperHeight);
      }

      let assembledDepth = '';
      if (
        variantData?.assembled_depth_in_mm.length > 0 ||
        variantData?.assembled_depth_inch.length > 0
      ) {
        const depthCm = variantData?.assembled_depth_in_mm.length > 0 ? (variantData?.assembled_depth_in_mm / 10).toFixed(2) : variantData?.assembled_depth_inch.length > 0 ? (variantData?.assembled_depth_inch * 2.54).toFixed(2) : '';
        const depthIn = variantData?.assembled_depth_inch.length > 0 ? variantData?.assembled_depth_inch : variantData?.assembled_depth_in_mm.length > 0 ? (variantData?.assembled_depth_in_mm / 25.4).toFixed(2) : '';
        if (variantData?.current_country === 'CA') {
          assembledDepth = `${depthCm} cm (${depthIn} in)`;
        } else {
          assembledDepth = `${depthIn} in (${depthCm} cm)`;
        }
      }
      if (assembledDepth.length > 0) {
        const itemWrapperDepth = document.createElement('li');
        itemWrapperDepth.classList.add('flex', 'flex-row', 'gap-2');
        itemWrapperDepth.innerHTML = `
          <div class="font-bold">${variantData?.translation_depth}:</div>
          <div>${assembledDepth}</div>
        `;
        textElements.appendChild(itemWrapperDepth);
      }

      let weightCapacity = '';
      if (variantData?.weight_capacity && variantData?.weight_capacity.value) {
        let toKgs = variantData?.weight_capacity?.value * 1;
        let toLbs = variantData?.weight_capacity?.value * 1;
        if (variantData?.weight_capacity?.unit === 'lb') {
          toKgs = variantData?.weight_capacity?.value * 0.453592;
        } else {
          toLbs = variantData?.weight_capacity?.value * 0.453592;
        }
        if (variantData?.current_country === 'CA') {
          weightCapacity = `${toKgs.toFixed(2)} Kg (${toLbs.toFixed(2)} lbs)`;
        } else {
          weightCapacity = `${toLbs.toFixed(2)} lbs (${toKgs.toFixed(2)} kg)`;
        }
      }

      if (weightCapacity.length > 0) {
        const itemWrapperWeightCapacity = document.createElement('li');
        itemWrapperWeightCapacity.classList.add('flex', 'flex-row', 'gap-2');
        itemWrapperWeightCapacity.innerHTML = `
          <div class="font-bold">${variantData?.translation_weight_capacity}:</div>
          <div>${weightCapacity}</div>
        `;
        textElements.appendChild(itemWrapperWeightCapacity);
      }

      // When the weight metafield is empty, Liquid outputs `[]` (truthy), so the
      // value must be validated before formatting or toFixed() throws and stops
      // the rest of the PDP from updating. Without a valid weight, the row is skipped.
      let weight = '';
      const weightInUnits = getWeightInKgAndLbs(variantData?.weight);
      if (weightInUnits) {
        const { kg, lbs } = weightInUnits;
        if (variantData?.current_country === 'CA') {
          weight = `${kg.toFixed(2)} Kg (${lbs.toFixed(2)} lbs)`;
        } else {
          weight = `${lbs.toFixed(2)} lbs (${kg.toFixed(2)} kg)`;
        }
      }
      if (weight.length > 0) {
        const itemWrapperWeight = document.createElement('li');
        itemWrapperWeight.classList.add('flex', 'flex-row', 'gap-2');
        itemWrapperWeight.innerHTML = `
          <div class="font-bold">${variantData?.translation_weight}:</div>
          <div>${weight}</div>
        `;
        textElements.appendChild(itemWrapperWeight);
      }

      wrapper.appendChild(textElements);

      // Boxes Dataset Rendering (designer format, robust parsing)
      const boxes = Array.isArray(variantData?.boxes_dataset)
        ? variantData.boxes_dataset
        : [];

      if (boxes.length > 0) {
        // Occupy columns 4–5 of the main 5-col grid
        const boxesWrapper = document.createElement('div');
        boxesWrapper.classList.add(
          'col-span-1',
          'md:col-span-2',
          'md:col-start-4'
        );

        // 1 col mobile, 2 col md+
        const boxesGrid = document.createElement('div');
        boxesGrid.classList.add(
          'grid',
          'grid-cols-1',
          'md:grid-cols-2',
          'gap-4'
        );

        // ---------- Helpers ----------
        const toCm = (inch) => inch * 2.54;
        const toIn = (cm) => cm / 2.54;

        const fmt = (n) => {
          if (!Number.isFinite(n)) return '';
          return parseFloat(n.toFixed(2)).toString(); // max 2 decimals, no trailing zeros
        };

        /**
         * Parse dimensions regardless of order.
         * Works with strings like:
         * - "61.81 in W x 28.13 in L x 12.81 in H"
         * - "28.13 in L x 61.81 in W x 12.81 in H"
         * - "1569.974 cm W x 714.502 cm L x 325.374 cm H"
         *
         * Strategy: find all "(number)(unit)(axis)" tokens and map by axis letter.
         */
        const parseDims = (str) => {
          if (!str || typeof str !== 'string') return null;

          // Capture groups: value, unit, axis
          // Examples matched:
          //  "61.81 in W" -> value=61.81 unit=in axis=W
          //  "714.502 cm L" -> value=714.502 unit=cm axis=L
          const re = /([0-9]+(?:\.[0-9]+)?)\s*(in|cm)\s*([WLH])\b/gi;

          const out = {
            w: { in: null, cm: null },
            l: { in: null, cm: null },
            h: { in: null, cm: null },
          };

          let m;
          while ((m = re.exec(str)) !== null) {
            const value = parseFloat(m[1]);
            const unit = (m[2] || '').toLowerCase(); // 'in' or 'cm'
            const axis = (m[3] || '').toUpperCase(); // 'W' | 'L' | 'H'
            if (!Number.isFinite(value)) continue;

            if (axis === 'W') out.w[unit] = value;
            if (axis === 'L') out.l[unit] = value;
            if (axis === 'H') out.h[unit] = value;
          }

          // If we didn’t find anything, return null
          const foundAny =
            Number.isFinite(out.w.in) ||
            Number.isFinite(out.w.cm) ||
            Number.isFinite(out.l.in) ||
            Number.isFinite(out.l.cm) ||
            Number.isFinite(out.h.in) ||
            Number.isFinite(out.h.cm);

          return foundAny ? out : null;
        };

        const lbsToKg = (lbs) => lbs * 0.45359237;
        const kgToLbs = (kg) => kg / 0.45359237;

        const parseWeight = (str) => {
          // Supports "123 lbs", "123 lb", "55 kg", "55 kgs"
          if (!str || typeof str !== 'string') return { lbs: null, kg: null };

          const lbsMatch = str.match(/([0-9]+(?:\.[0-9]+)?)\s*lb[s]?\b/i);
          const kgMatch = str.match(/([0-9]+(?:\.[0-9]+)?)\s*kg[s]?\b/i);

          return {
            lbs: lbsMatch ? parseFloat(lbsMatch[1]) : null,
            kg: kgMatch ? parseFloat(kgMatch[1]) : null,
          };
        };

        const formatPair = (cm, inch, cmUnit = 'cm', inUnit = 'in') => {
          // Avoid showing empty parentheses if one side missing
          const hasCm = Number.isFinite(cm);
          const hasIn = Number.isFinite(inch);

          if (!hasCm && !hasIn) return '';

          // Prefer "cm (in)" output
          const left = hasCm ? `${fmt(cm)} ${cmUnit}` : '';
          const right = hasIn ? `${fmt(inch)} ${inUnit}` : '';

          if (left && right) return `${left} (${right})`;
          return left || right;
        };

        let packageIndex = 0;

        boxes.forEach((box) => {
          const boxCount = Number(box?.box_count || 0);
          if (!boxCount || boxCount <= 0) return;

          packageIndex++;

          const parsed = {
            inches: parseDims(box?.concat_box_dimensions_inches),
            cms: parseDims(box?.concat_box_dimensions_cm),
          };

          // Pull values by axis, tolerant of order
          // Width -> W, Depth -> L, Height -> H
          let widthIn = parsed.inches?.w?.in ?? null;
          let depthIn = parsed.inches?.l?.in ?? null;
          let heightIn = parsed.inches?.h?.in ?? null;

          // concat_box_dimensions_cm is unreliable (values are sometimes entered
          // in mm but labeled cm), so derive cm from the trustworthy inches value
          // whenever inches is available, only falling back to the raw cm field
          // when inches is missing entirely.
          let widthCm = Number.isFinite(widthIn) ? toCm(widthIn) : (parsed.cms?.w?.cm ?? null);
          let depthCm = Number.isFinite(depthIn) ? toCm(depthIn) : (parsed.cms?.l?.cm ?? null);
          let heightCm = Number.isFinite(heightIn) ? toCm(heightIn) : (parsed.cms?.h?.cm ?? null);

          if (!Number.isFinite(widthIn) && Number.isFinite(widthCm))
            widthIn = toIn(widthCm);
          if (!Number.isFinite(depthIn) && Number.isFinite(depthCm))
            depthIn = toIn(depthCm);
          if (!Number.isFinite(heightIn) && Number.isFinite(heightCm))
            heightIn = toIn(heightCm);

          // Weight conversions
          const w = parseWeight(box?.box_weight);
          let lbs = w.lbs;
          let kg = w.kg;

          if (!Number.isFinite(kg) && Number.isFinite(lbs)) kg = lbsToKg(lbs);
          if (!Number.isFinite(lbs) && Number.isFinite(kg)) lbs = kgToLbs(kg);

          const widthValue = formatPair(widthCm, widthIn);
          const depthValue = formatPair(depthCm, depthIn);
          const heightValue = formatPair(heightCm, heightIn);
          const weightValue = formatPair(kg, lbs, 'kg', 'lbs');

          // Package cell (no borders/boxes)
          const packageDiv = document.createElement('div');
          packageDiv.classList.add('flex', 'flex-col', 'gap-2');

          const title = document.createElement('div');
          title.classList.add('font-bold');
          title.textContent = isEnglish ? `Package #${packageIndex}` : `Boîte #${packageIndex}`;
          packageDiv.appendChild(title);

          const table = document.createElement('table');
          table.classList.add('collapsible-dimensions__table');

          // Bold labels + padding between label and value (pr-3)
          table.innerHTML = `
            <tbody>
              <tr>
                <td class="font-bold pr-3 whitespace-nowrap">
                  ${variantData?.translation_width || 'Width'}:
                </td>
                <td>${widthValue}</td>
              </tr>
              <tr>
                <td class="font-bold pr-3 whitespace-nowrap">
                  ${variantData?.translation_depth || 'Depth'}:
                </td>
                <td>${depthValue}</td>
              </tr>
              <tr>
                <td class="font-bold pr-3 whitespace-nowrap">
                  ${variantData?.translation_height || 'Height'}:
                </td>
                <td>${heightValue}</td>
              </tr>
              <tr>
                <td class="font-bold pr-3 whitespace-nowrap">
                  ${variantData?.translation_weight || 'Weight'}:
                </td>
                <td>${weightValue}</td>
              </tr>
              <tr>
                <td class="font-bold pr-3 whitespace-nowrap">
                  ${variantData?.translation_box_count || 'Box count'}:
                </td>
                <td>${boxCount}</td>
              </tr>
            </tbody>
          `;

          packageDiv.appendChild(table);
          boxesGrid.appendChild(packageDiv);
        });

        if (boxesGrid.children.length > 0) {
          const totalBoxCount = Number(variantData?.total_box_count || 0);
          if (totalBoxCount > 0 && variantData?.translation_ships_in_boxes) {
            const totalBoxes = document.createElement('div');
            totalBoxes.classList.add('font-bold', 'mb-4');
            totalBoxes.textContent = variantData.translation_ships_in_boxes;
            boxesWrapper.appendChild(totalBoxes);
          }
          boxesWrapper.appendChild(boxesGrid);
          wrapper.appendChild(boxesWrapper);
        }
      }

      variantDimensionsEl.appendChild(wrapper);

      // mediumZoom('[data-zoomable]')

      if (lightboxDimension) {
        lightboxDimension.destroy();
        lightboxDimension = null;
      }

      lightboxDimension = new PhotoSwipeLightbox({
        gallery: '.dimension_gallery', // container
        children: 'a', // items inside
        pswpModule: PhotoSwipe, // <-- no dynamic import
      });

      lightboxDimension.init();
    }

    const variantFeaturesEl = document.querySelector(
      '[data-filter-tab-features]'
    );

    if (variantFeaturesEl) {
      variantFeaturesEl.innerHTML = variantData?.features ? variantData.features : variantFeaturesEl.dataset.filterTabFeatures;
    }

    const variantSpecificationsEl = document.querySelector(
      '[data-filter-tab-specifications]'
    );

    if (variantSpecificationsEl) {
      variantSpecificationsEl.innerHTML = variantData?.specifications ? variantData.specifications : variantSpecificationsEl.dataset.filterTabSpecifications;
    }

    const variantWarrantyParentEl = document.querySelector(
      '[data-warranty-parent]'
    );
    if (variantWarrantyParentEl) {
      if (variantWarrantyEl.innerHTML.length > 0) {
        variantWarrantyParentEl.classList.remove('hidden');
      } else {
        variantWarrantyParentEl.classList.add('hidden');
      }
    }

    // update assembly instructions
    const allAssemblyInstructions = document.querySelectorAll('[data-assembly-instructions]');
    if (allAssemblyInstructions.length > 0) {
      allAssemblyInstructions.forEach((item) => {
        if (item.dataset.assemblyInstructions === variantId) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    }

    // update box count
    document.querySelectorAll('[data-variant-box-count]').forEach((item) => {
      item.classList.toggle('hidden', item.dataset.variantBoxCount !== variantId);
    });

    // renumber assembly instructions
    const listAssemblyInstructions = document.querySelectorAll('[data-list-assembly-instructions] > a:not(.hidden)');
    if (listAssemblyInstructions.length > 0) {
      let newIndex = 1
      listAssemblyInstructions.forEach((item, index) => {
        const indexEl = item.querySelector('[data-assembly-index]');
        if (indexEl) {
          indexEl.textContent = newIndex;
          newIndex++;
        }
      });
    }
  }

  const parseHtmlEscapedJson = (htmlString) => {
    const decoded = htmlString
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
    return JSON.parse(decoded);
  }

  const handleAddToCartClick = async (e) => {
    e.preventDefault();

    const variantId = addToCartButton.dataset.variantId;

    const itemToAdd = [
      {
        id: Number(variantId),
        quantity: 1,
      },
    ];
    await addToCart(itemToAdd);

    // Emit event to open cart
    document.dispatchEvent(new CustomEvent('cart:open'));
  };

  const initAddToCartButton = () => {
    addToCartButton = node.querySelector('[button-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', handleAddToCartClick);
    }
  };

  const initPopupVariantContainers = () => {

    const allPopupVariantContainers = node.querySelectorAll(
      '[data-popup-variant-container]'
    );
    allPopupVariantContainers.forEach((container) => {
      const button = container.querySelector('[data-popup-variant-button]');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const popupVariantContent = container.querySelector(
            '[data-popup-variant-content]'
          );
          const closeButton = container.querySelector(
            '[data-popup-variant-close]'
          );
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            popupVariantContent.classList.add('hidden');
          });
          popupVariantContent.classList.toggle('hidden');
        });
      }
    });
  };

  /**
   * Init
   */
  const init = () => {

    document.addEventListener('new-variant:change', (e) => {
      const variantId = e.detail.variant;
      handleVariantButtonClick(variantId);

      initAddToCartButton()
      initPopupVariantContainers()

      const isAvailable = e.detail.available;
      if (isAvailable && isAvailable === "false") {
        updateBackInStockButton(variantId);
      }

    });

    initAddToCartButton()
    initPopupVariantContainers()



    // first time update content based on variant
    handleVariantButtonClick(addToCartButton.dataset.variantId);
  };

  init();
};
